import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124.171 21.34-.029 18.521.003 16",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M31.997 16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.662 2.752.862 5.57.83 8.091",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M5.333 7.333h21.333v17.333H5.333z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M5.334 22s5.61-3.064 10.666-3.2c5.056-.135 10.667 3.2 10.667 3.2v2.667H5.334z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m7.993 22.761.623.504-.632.324c1.63.556 3.285-.616 3.573-.834.28.15 1.851.927 4.454.927 2.501 0 4.039-.71 4.412-.904.422.662 2.703 1.117 3.56.79l-.634-.345.562-.492c-2.685.129-3.111-.74-3.577-.932-.38.425-1.988.778-4.323.778-2.305 0-4.5-.778-4.5-.778s-1.22 1.266-3.518.962",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "m16.381 12.852.473.148c.211-.404.397-1.798.38-1.848 0 0 .484.222.799.708.03-.317-.2-.9-.548-1.38 0 0 1.725.468 1.891.577-.297-.534-1.29-1.205-1.899-1.301.463-.272 2.397.97 2.474 1.007-.105-.985-.914-1.277-1.483-1.511.471-.265 1.613.36 1.866.286-.432-.898-2.01-.834-3.059-.551.202-.354 1.897-.53 2.101-.572-.307-.236-1.587-1.065-3.217.604l-.626.025c-1.642-1.703-2.934-.867-3.242-.629.452-.106 1.304.075 1.261.343-1.374-.218-2.017.16-2.218.58.252.074 1.071-.274 1.784-.212-.375.15-1.297.452-1.402 1.437.077-.037 1.18-.914 2.374-.937-.97.401-1.502.697-1.8 1.231.222.041 1.892-.576 1.892-.576-.348.479-.578 1.062-.548 1.379.314-.486 1.18-.755 1.18-.755s-.396.707-.36 1.142c0 0 .148.35.36.753 0 0 .368-.476.431-.553l.436-1.973.773.007z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16.045 19.578q3.406 2.859 5.98.714 2.572-2.144-1.358-6.959L16 16l-4.664-2.667q-3.932 4.815-1.358 6.96 2.574 2.143 5.98-.715",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16 10c.368 0 .667.299.667.667v8.666a.667.667 0 1 1-1.334 0v-8.666c0-.368.299-.667.667-.667",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagHti = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagHti_default = SvgFlagHti;

export { FlagHti_default as default };
